import React from "react";
import { useGetAboutMe } from "pages/Profile/hooks/useGetAboutMe";

const AboutMePrint = () => {
  const { aboutMe } = useGetAboutMe();

  if (!aboutMe?.currentAppearance) return null;

  return <p className="mb-2.5">{aboutMe.currentAppearance}</p>;
};

export default AboutMePrint;
